// extracted by mini-css-extract-plugin
module.exports = {"ContentBox":"ContentBox_ContentBox__loNUI","hasTitle":"ContentBox_hasTitle__3KHB7","Title":"ContentBox_Title__3jfcZ"};